import type { EnumUnion } from '@dresscode-frontend/utility-types';

/**
 * 組織図表示の共通定数定義
 */
export const ViewMode = {
  HIERARCHY: 'hierarchy',
  TREE: 'tree',
  TABLE: 'table',
} as const;
export type ViewMode = EnumUnion<typeof ViewMode>;
